<script lang="ts" setup>
import { Status } from '@injectivelabs/utils'

const props = defineProps({
  isLoading: Boolean,

  status: {
    type: Object as PropType<Status>,
    default: () => new Status()
  }
})

const showLoading = computed(() => props.isLoading || props.status.isLoading())
</script>

<template>
  <div class="h-full-flex">
    <Suspense>
      <div v-if="showLoading" class="flex grow items-center py-6">
        <AppSpinner is-lg primary />
      </div>
      <slot v-else />
      <template #fallback>
        <div class="flex grow items-center">
          <AppSpinner is-lg primary />
        </div>
      </template>
    </Suspense>
  </div>
</template>
